/* eslint-disable max-lines */
/* global window */
import xmpp from 'ragnarok-web/dist/XMPP/XMPPClient';
import Chat from 'ragnarok-web/dist/Chat';
import { getChatApiMetaData } from 'ragnarok-web/dist/XHR';
import store from './store';
import { setSafetyTipsValidity, setSafetyTipsData, readSafetyTipsData, hasSafetyTipsData } from 'Helpers/safetyTips';
import { setReplyRestrictionData, readReplyRestrictionData, setKYCReplyRestrictionData, setKYCReplyRestrictionSellerData, setAPICallDelay } from 'Helpers/replyRestriction';
import { saveSafetyTips, saveReplyRestrictionMetaData, saveKYCReplyRestrictionData, saveMyZoneFeatureFlag, saveIntentCtas, setChatQuickFilters } from 'Actions/chatManager';
import { urls as urlsItems } from 'Reducers/items';
import { urls as urlsUsers } from 'Reducers/users';
import { urls as urlsStaticMap } from 'Reducers/maps';
import { getUserImage, convertToAbsoluteImageURI } from 'Helpers/images';
import { getImageSize } from 'Helpers/urlImageSize';
import withConfig from 'HOCs/withConfig/withConfig';
import withCustomRouter from 'HOCs/withCustomRouter/withCustomRouter';
import { Link } from 'react-router-dom';
import withDirection from 'HOCs/withDirection/withDirection';
import withReplyRestriction from 'HOCs/withReplyRestriction/withReplyRestriction';
import { setQuickFilterFeatureFlag } from 'Helpers/quickFilters';
import cookieManagerHelper from 'Helpers/cookies';
import * as flows from './flows/async';
import FullScreenImageGallery from 'Components/FullScreenImageGallery/FullScreenImageGallery';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import Auth from './Auth';
import * as httpMethods from 'Server';
import { getItemUrl, buildURL } from 'Helpers/url';
import {
    BIFROST_FEATURES,
    BIFROST_STORED_DATA_TIME,
    BIFROST_STORED_DATA,
    BIFROST_LANG,
    MESSAGE_TTL_DAYS,
    PRICING_ENGINE,
    KYC_REPLY_RESTRICTION,
    KYC_REPLY_RESTRICTION_SELLER,
    KYC_REPLY_RESTRICTION_LIMIT,
    KYC_REPLY_RESTRICTION_SELLER_LIMIT
} from 'ragnarok-web/dist/Constants/constants';
import {
    setQuestionCloudCategories,
    setSuggestionsVisibilityLimit,
    setAutoReplyCategories,
    savePricingEngineCategories
} from 'ragnarok-web/dist/Helpers/featureHelper';
import { fileNames } from 'Constants/imageUrls';
import { SVG_EXT } from 'Constants/images';
import { isFetchingItem } from 'Selectors/items';
import * as configSelectors from 'Selectors/config';
import { urls as urlsConfig } from 'Reducers/config';
import * as locationSelectors from 'Selectors/location';
import setToastMessageState from 'Actions/setToastMessageState';
import { getCategoryById } from 'Actions/categories';
import withTrack from 'HOCs/withTrack/withTrack';
import ItemLeadForm from './pages/Item/components/ItemLeadForm/AsyncItemLeadForm';
import AsyncMarkAsSoldModal from 'Components/SellerCallToAction/AsyncMarkAsSoldModal';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';
import { getMyAdTrackInfo } from 'Helpers/track';
import { MyAdsFlowType } from 'Constants/tracking';
import { isEmpty } from 'Helpers/objects';
import 'ragnarok-web/dist/Components/UserKycPopup/UserKycPopup.scss';
import 'ragnarok-web/dist/Components/UserKycPopup/KycPopupConfig.scss';
import { setOrigin } from 'Actions/track';
import AsyncConfirmModal from 'Components/ConfirmModal/AsyncConfirmModal';
import ChatDataLoader from './pages/Chat/ChatDataLoader';
import { canMarkAsSold } from 'Helpers/adActionStatus';
import { saveB2CMeetingData } from 'Actions/meetings';
import { saveFeatureFlagData } from 'Actions/features';
import { setMyZoneQuickFilters } from 'Actions/myzone';
import ItemImage from 'Components/Listing/components/ItemImage';
import IntentButtons from './pages/MyZone/CTA/IntentButtons/AsyncIntentButtons';
import MyZoneDataLoader from './pages/MyZone/MyZoneDataLoader';
import withFeatureFlags from 'HOCs/withFeatureFlags/withFeatureFlags';
import { ChatDatabase } from 'ragnarok-web/dist/Database';
import withRouter from 'HOCs/withRouter';
import CompareIconCTA from 'Components/Compare/CompareIconCTA/CompareIconCTA';

class ChatWrapper {
    static loadType = false;

    static interventionData = null;

    static systemMessageData = null;

    static XMPP = null;

    static instantiateXMPP(callback, config, theme) {
        const illustrationTipsMedium = convertToAbsoluteImageURI(fileNames.IMG_TIPS, SVG_EXT, '', '', '', theme);

        Chat.init({
            urlsItems,
            urlsUsers,
            getUserImage,
            getImageSize,
            withCustomRouter,
            Link,
            withConfig,
            withDirection,
            FullScreenImageGallery,
            ImageWrapper,
            staticMapApiUrl: urlsStaticMap.getStaticMapUrl,
            Auth,
            httpMethods,
            getItemUrl,
            illustrationTipsMedium,
            withReplyRestriction,
            isFetchingItem,
            configSelectors,
            locationSelectors,
            buildURL,
            setToastMessageState,
            getCategoryById,
            withTrack,
            urlsConfig,
            ItemLeadForm,
            AsyncMarkAsSoldModal,
            setOrigin,
            TrackerOrigins,
            getMyAdTrackInfo,
            MyAdsFlowType,
            AsyncConfirmModal,
            canMarkAsSold,
            ChatDataLoader,
            ItemImage,
            IntentButtons,
            MyZoneDataLoader,
            withFeatureFlags,
            withRouter,
            CompareIconCTA
        });
        if (config.disabled) {
            return;
        }
        this.createPromise(config).then(() => {
            if (!this.XMPP) {
                const module = xmpp(store);

                this.XMPP = module;
            }
            callback(this.XMPP, this.interventionData, this.systemMessageData, this.shouldRefreshData);
        });
    }

    static loadOfflineThreads(user) {
        const chatDb = new ChatDatabase(store);

        chatDb.fetchThreadData(user.id);
    }

    static createPromise(config) {
        this.shouldRefreshData = false;
        if (!this.loadingPromise) {
            if (config) {
                this.loadingPromise = this.getChatMetaData(config);
            }
            else {
                this.loadingPromise = new Promise(resolve => {
                    resolve(false);
                });
            }
        }
        return this.loadingPromise;
    }

    static importChat() {
        return this.createPromise().then(loadInfo => {
            this.loadType = loadInfo;

            return flows.importChat();
        });
    }

    static importMyZone() {
        return this.createPromise().then(loadInfo => {
            this.loadType = loadInfo;
            return flows.importMyZone();
        });
    }

    static importMyZoneFinance() {
        return this.createPromise().then(loadInfo => {
            this.loadType = loadInfo;
            return flows.importMyZoneFinance();
        });
    }

    static fetchAndProcessData(config) {
        return getChatApiMetaData(config).then(data => {
            const processedData = data.data;

            this.processData(processedData);
            return processedData.features && processedData.features.threadbased_loading;
        }).catch(() => {});
    }

    static saveSafetyTipsData(data) {
        store.dispatch(saveSafetyTips(data));
        setSafetyTipsData(data);
    }

    /**
     *
     * @param {boolean} my_zone
     */
    static saveMyZoneFeatureFlag(my_zone) {
        store.dispatch(saveMyZoneFeatureFlag({ my_zone }));
    }

    /**
     *
     * @param {boolean} intentCtas
     */
    static saveIntentCtas(intentCtas) {
        store.dispatch(saveIntentCtas({ intentCtas }));
    }

    /**
     * Reads the Safety Tips data from the localStorage
     * and loads in into the redux store
     */
    static loadSafetyTipsData() {
        const safetyTips = readSafetyTipsData();

        if (Object.keys(safetyTips).length) {
            store.dispatch(saveSafetyTips(safetyTips));
        }
    }

    /**
     * Reads the Reply restriction data from the localStorage
     * and loads in into the redux store
     */
    static loadReplyRestrictionData() {
        const replyRestriction = readReplyRestrictionData();

        if (replyRestriction && Object.keys(replyRestriction).length) {
            store.dispatch(saveReplyRestrictionMetaData(replyRestriction));
        }
    }

    /**
     * Fetches the chat meta data/startup api response
     * if already present in client's storage, it will retrive it from there
     * @param {*} config
     * @param {*} val by default it assumes to check the last time's stored data
     */
    static getChatMetaData(config, val = true) {
        const state = store.getState();
        const updatedConfig = { ...config, ...{
            lang: state.api && state.api.queryParam && state.api.queryParam.lang
        }};

        if (val && !this.checkLastStoredData()) {
            const rawData = window.localStorage && window.localStorage.getItem(BIFROST_FEATURES);
            let deferredData;

            this.loadSafetyTipsData();
            this.loadReplyRestrictionData();

            let data = null;

            try {
                data = JSON.parse(rawData);
            }
            finally {
                deferredData = data ? Promise.resolve(data.threadbased_loading) : this.fetchAndProcessData(updatedConfig);
            }
            return deferredData;
        }
        return this.fetchAndProcessData(updatedConfig);
    }

    /**
     * checks if there is a stored data from last time(dont ask :)
     * NOTE: it assumes there is a data in SSR
     */
    static checkLastStoredData() {
        const no = 3600000;

        if (typeof window !== 'undefined') {
            const lastTime = window.localStorage && window.localStorage.getItem(BIFROST_STORED_DATA_TIME);
            const sessionKey = window.sessionStorage && window.sessionStorage.getItem(BIFROST_STORED_DATA);
            const langKey = window.localStorage && window.localStorage.getItem(BIFROST_LANG);
            const cookieLang = cookieManagerHelper.readCookie('lang');

            return !sessionKey || !lastTime || !hasSafetyTipsData() || (Date.now() - lastTime) / no > 1 || cookieLang !== langKey;
        }
        return true;
    }

    static saveReplyRestrictionMetaData = data => {
        store.dispatch(saveReplyRestrictionMetaData(data));
    }

    static setKYCReplyRestrictionFeatureData = data => {
        if (data.features
            && data.features[KYC_REPLY_RESTRICTION]
            && !isEmpty(data[KYC_REPLY_RESTRICTION_LIMIT])) {
            store.dispatch(saveKYCReplyRestrictionData(data[KYC_REPLY_RESTRICTION_LIMIT]));
            setKYCReplyRestrictionData(data[KYC_REPLY_RESTRICTION_LIMIT]);
        }
        if (data.features
            && data.features[KYC_REPLY_RESTRICTION_SELLER]
            && !isEmpty(data[KYC_REPLY_RESTRICTION_SELLER_LIMIT])) {
            store.dispatch(saveKYCReplyRestrictionData(data[KYC_REPLY_RESTRICTION_SELLER_LIMIT]));
            setKYCReplyRestrictionSellerData(data[KYC_REPLY_RESTRICTION_SELLER_LIMIT]);
        }
    }

    static setAPICallDelayTime = data => setAPICallDelay(data.kyc_api_call_delay);

    static saveB2CMeetingData = data => {
        store.dispatch(saveB2CMeetingData(data));
    }

    static saveFeatureFlagData = data => {
        store.dispatch(saveFeatureFlagData(data));
    }

    static saveQuickFilters = data => {
        store.dispatch(setChatQuickFilters(data.quick_filters));
        store.dispatch(setMyZoneQuickFilters(data.myzone_quick_filters));
    }

    static processData(data) {
        if (data.features) {
            const localStorage = window && window.localStorage;
            const { my_zone } = data.features;

            if (localStorage) {
                localStorage.setItem(BIFROST_FEATURES, JSON.stringify(data.features));
                localStorage.setItem(BIFROST_STORED_DATA_TIME, Date.now());
                window.sessionStorage.setItem(BIFROST_STORED_DATA, true);
                const cookieLang = cookieManagerHelper.readCookie('lang');
                const langKey = window.localStorage && window.localStorage.getItem(BIFROST_LANG);

                if (cookieLang) {
                    this.shouldRefreshData = cookieLang !== langKey;
                    localStorage.setItem(BIFROST_LANG, cookieLang);
                }

                if (data.message_ttl_in_days) {
                    localStorage.setItem(MESSAGE_TTL_DAYS, data.message_ttl_in_days);
                }
                setQuickFilterFeatureFlag(!!data.features['quick_filters']);
                setQuestionCloudCategories(data.features.question_cloud, data);
                setSuggestionsVisibilityLimit(data.suggestions_visible_limit);
                setAutoReplyCategories(data.features.auto_reply, data);

                // pricing engine
                savePricingEngineCategories(data.features[PRICING_ENGINE], data);
            }
            // save my_zone and is_reserved feature flags
            // if the flags are not present setting them as false
            this.saveMyZoneFeatureFlag(!!my_zone);
        }
        if (data.interventions) {
            this.interventionData = data.interventions;
        }

        if (data.system_messages) {
            this.systemMessageData = data.system_messages;
        }

        if (data.intent_ctas) {
            this.saveIntentCtas(data.intent_ctas);
        }

        if (data.safety_tips) {
            const safetyTips = data.safety_tips;

            setSafetyTipsValidity(safetyTips.display_frequency_days);
            this.saveSafetyTipsData(safetyTips.safety_tips);
        }

        this.setKYCReplyRestrictionFeatureData(data);

        if (data.features.reply_restriction) {
            const replyRestrictionConfig = (({ reply_restriction_error_text, reply_restriction_user_error_text }) =>
                ({ reply_restriction_error_text, reply_restriction_user_error_text }))(data);

            setReplyRestrictionData(replyRestrictionConfig);
            this.saveReplyRestrictionMetaData(replyRestrictionConfig);
        }
        this.setAPICallDelayTime(data);
        this.saveB2CMeetingData(data);
        this.saveFeatureFlagData(data);
        this.saveQuickFilters(data);
    }
}

export default ChatWrapper;
